import { useEffect, useRef } from "react";
import { prepareTIFF } from "../../../util";

const ImageZoomView = props => {
  const { src, zoomSrc, isJpeg = false } = props || {};
  const imgContainer = useRef(null);
  const zoomImgContainer = useRef(null);

  useEffect(async () => {
    src &&
      !isJpeg &&
      prepareTIFF({ url: src }).then(canvas => {
        canvas.style.objectFit = "contain";
        canvas.style.height = "100%";
        canvas.style.width = "100%";
        // add canvas as child element
        imgContainer?.current?.firstChild &&
          imgContainer?.current?.removeChild(imgContainer?.current?.firstChild);
        imgContainer?.current?.appendChild(canvas);
      });

    zoomSrc &&
      !isJpeg &&
      prepareTIFF({ url: zoomSrc }).then(canvas => {
        canvas.style.objectFit = "contain";
        // add canvas as child element
        zoomImgContainer?.current?.firstChild &&
          zoomImgContainer?.current?.removeChild(
            zoomImgContainer?.current?.firstChild,
          );
        zoomImgContainer?.current?.appendChild(canvas);
      });
  }, [src, zoomSrc]);

  return (
    <div className="group relative h-16 w-16">
      <div className="flex h-16 w-16 items-center justify-center overflow-hidden">
        {isJpeg ? (
          <img className="flex h-auto w-full" src={src} />
        ) : (
          <div className="flex h-auto w-full" ref={imgContainer} />
        )}
      </div>
      <div
        ref={zoomImgContainer}
        style={{
          height: 255,
          ...(isJpeg && {
            width: 255,
            backgroundImage: `url(${zoomSrc || ""})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }),
        }}
        className="absolute left-20 top-0 z-10 hidden overflow-hidden rounded bg-gray-300 group-hover:flex"
      />
    </div>
  );
};

export { ImageZoomView };
